import {Service} from '@angular/core';
import {EntitySearchCriteria} from '../entity/entity-search-criteria';

@Service()
export class InputCacheService {

  criteria!: EntitySearchCriteria;

}
